import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';

/**
 * Bootstraps the React application.
 */
const mount = () => {
  const container = document.getElementById('root');
  if (!container) {
    console.error('[STUDIO] Fatal: Root container missing.');
    return;
  }

  try {
    const root = createRoot(container);
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
    console.log('[STUDIO] Application mounted successfully.');
  } catch (err) {
    console.error('[STUDIO] React mount error:', err);
    // Force show error on screen if render fails
    if (window.onerror) {
      window.onerror(
        typeof err === 'string' ? err : (err as Error).message,
        'index.tsx',
        0,
        0,
        err as Error
      );
    }
  }
};

// Start when script loads
mount();
